import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnassigned = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20.809,
	viewBox: "0 0 21 20.809",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_10090",
		"data-name": "Group 10090",
		transform: "translate(-756.875 -563.795)",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_169",
			"data-name": "Ellipse 169",
			cx: 8.188,
			cy: 8.188,
			r: 8.188,
			transform: "translate(759 567)",
			fill: "#eeeef9"
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_4828",
			"data-name": "Group 4828",
			transform: "translate(757.375 564.295)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_4829",
				"data-name": "Group 4829",
				transform: "translate(0 0)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_10091",
					"data-name": "Group 10091",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Path_8297",
						"data-name": "Path 8297",
						d: "M8.761,13.26s-1.3-.44-1.3-2.64c-.718,0-.718-1.76,0-1.76,0-.295-1.3-3.52.87-3.08.435-1.76,5.217-1.76,5.652,0a7.046,7.046,0,0,1-.435,3.08c.718,0,.718,1.76,0,1.76,0,2.2-1.3,2.64-1.3,2.64v2.2a30.2,30.2,0,0,1,5.379,2.266A10.144,10.144,0,0,0,10.5.5,10.145,10.145,0,0,0,3.391,17.736a30.714,30.714,0,0,1,5.37-2.277Z",
						transform: "translate(-0.5 -0.5)",
						fill: "#eeeef9",
						stroke: "#7284fa",
						strokeLinejoin: "round",
						strokeWidth: 1
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_8298",
						"data-name": "Path 8298",
						d: "M3.825,20.085a10.8,10.8,0,0,0,7.307,2.764,10.793,10.793,0,0,0,7.316-2.774",
						transform: "translate(-1.132 -3.04)",
						fill: "#eeeef9",
						stroke: "#7284fa",
						strokeLinejoin: "round",
						strokeWidth: 1
					})]
				})
			})
		})]
	})
});
export default SvgUnassigned;
